import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Shared axios instance. Attaches the auth token on every request so pages
 * don't each rebuild headers, and normalises server errors into a readable
 * message for toasts.
 */
const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/") window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

/** Pulls the most useful message out of an axios error. */
export function errMsg(error, fallback = "Something went wrong") {
  const data = error?.response?.data;
  return (
    data?.message ||
    data?.error?.errors?.[0]?.message ||
    (typeof data?.error === "string" ? data.error : null) ||
    error?.message ||
    fallback
  );
}

export default api;
